<template>
  <div>
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Informacje zgłoszeniowe</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    </v-card>
    <v-card class="mt-2 pb-1">
      <v-form @submit.prevent="updateRunner"novalidate>
        <resp-header color="tertiary">
          <template slot="left">
            SPRZĘTOWE
          </template>
          <span slot="right">
            Wypełnij poniższe dane aby trener mógł sporządzić optymalny dla Ciebie plan treningowy
          </span>
        </resp-header>
        <v-layout row justify-center class="grid-gap my-4">
          <v-flex xs12 sm12 md5 lg4>
              <runner-step-field
                :editable="updateMode"
                label="Zegarek z funkcją GPS"
                v-model="form.gps_watch"
                :objValue="runner.gps_watch ? 'TAK' : 'NIE'"
                :formErrors="formErrors"
                :field="'gps_watch'">

                <v-switch
                  :label="`Zegarek z funkcją GPS: ${form.gps_watch ? 'TAK' : 'NIE'}`"
                  v-model="form.gps_watch"
                ></v-switch>
              </runner-step-field>

              <runner-step-field
                :editable="updateMode"
                label="Zegarek z funkcją mierzenia tętna"
                v-model="form.pulse_watch"
                :objValue="runner.pulse_watch ? 'TAK' : 'NIE'"
                :formErrors="formErrors"
                :field="'pulse_watch'">

                <v-switch
                  :label="`Zegarek z funkcją mierzenia tętna: ${form.pulse_watch ? 'TAK' : 'NIE'}`"
                  v-model="form.pulse_watch"
                ></v-switch>
              </runner-step-field>

              <runner-step-field
                :editable="updateMode"
                label="Marka i model zegarka"
                v-model="form.watch_model"
                :objValue="runner.watch_model"
                :formErrors="formErrors"
                :field="'watch_model'"></runner-step-field>
              <runner-step-field
                :editable="updateMode"
                label="Marka i model butów biegowych"
                v-model="form.shoes_model"
                :objValue="runner.shoes_model"
                :formErrors="formErrors"
                :field="'shoes_model'"></runner-step-field>
          </v-flex>
        </v-layout>
        <v-toolbar flat dense dark color="tertiary">
          <v-toolbar-title>POZOSTAŁE</v-toolbar-title>
        </v-toolbar>
        <v-layout row justify-center wrap class="grid-gap my-4">
          <v-flex xs12 sm12 md5 lg4>
              <runner-step-field
                :editable="updateMode"
                label="Inne aplikacje biegowe"
                description="Konta na innych platformach biegowych np. GarminConnect, PolarFlow, Endomondo itp."
                v-model="form.other_running_platforms_accounts"
                :objValue="runner.other_running_platforms_accounts || 'NIE'"
                :formErrors="formErrors"
                placeholder="jeśli tak to na jakich?"
                :field="'other_running_platforms_accounts'"></runner-step-field>

              <runner-step-field
                v-if="runner.package_with_tshirt"
                :editable="updateMode"
                label="Rozmiar koszulki"
                v-model="form.tshirt_size"
                :objValue="runner.tshirt_size_display"
                :formErrors="formErrors"
                :field="'tshirt_size'">
                  <template slot-scope="{ error, label, errorMessages}">
                    <v-select
                      v-model="form.tshirt_size"
                      :error="error"
                      :hide-details="!error"
                      :error-messages="errorMessages"
                      :label="label"
                      :items="tshirtSizeOptions">
                    </v-select>
                    <span class="v-messages theme--light">
                      Sprawdź rozmiar:
                        <v-tooltip open-delay="100" bottom>
                            <span color="primary" slot="activator" id="womanTshirtSize" class="primary--text">damskie</span>
                            <img src="@/assets/img/damskie.png" />
                        </v-tooltip>,
                        <v-tooltip open-delay="100" bottom>
                            <span color="primary" slot="activator" id="manTshirtSize" class="primary--text">męskie</span>
                            <img src="@/assets/img/meskie.png" />
                        </v-tooltip>
                    </span>
                  </template>
              </runner-step-field>
              <runner-step-field
                :editable="updateMode"
                label="Udział w zawodach*"
                description="Częstotliwość uczestnictwa w zawodach"
                v-model="form.race_frequency"
                :objValue="runner.race_frequency_display"
                :formErrors="formErrors"
                :field="'race_frequency'">
                  <template slot-scope="{ error, errorMessages, label}">
                    <v-select
                      v-model="form.race_frequency"
                      :error="error"
                      :error-messages="errorMessages"
                      :label="label"
                      :items="raceFrequencyOptions">
                    </v-select>
                  </template>
              </runner-step-field>
              <runner-step-field
                :editable="updateMode"
                label="Wyrażam zgodę na rozpoczęcie realizacji usługi przed upływem 14-dniowego terminu na odstąpienie od umowy zawartej na odległość, wynikającego z art. 27 ustawy z 30 maja 2014 roku o prawach konsumenta. Jednocześnie przyjmuję do wiadomości, że wyrażenie powyższej zgody jest jednoznaczne z utratą prawa do odstąpienia od umowy (art. 38 pkt. 13 ustawy z 30 maja 2014 roku o prawach konsumenta).*"
                v-model="form.contract"
                :objValue="runner.contract ? 'TAK' : 'NIE'"
                :formErrors="formErrors"
                :field="'contract'">
                <template slot-scope="{ error, label, errorMessages}">
                  <v-checkbox
                    v-model="form.contract"
                    :error="error"
                    :errorMessages="errorMessages"
                    :label="`Wyrażam zgodę na rozpoczęcie realizacji usługi przed upływem 14-dniowego terminu na odstąpienie od umowy zawartej na odległość, wynikającego z art. 27 ustawy z 30 maja 2014 roku o prawach konsumenta. Jednocześnie przyjmuję do wiadomości, że wyrażenie powyższej zgody jest jednoznaczne z utratą prawa do odstąpienia od umowy (art. 38 pkt. 13 ustawy z 30 maja 2014 roku o prawach konsumenta).*`"
                  ></v-checkbox>
                </template>
              </runner-step-field>
          </v-flex>

          <v-flex xs12 sm12 md5 lg4>
              <runner-step-field
                :editable="updateMode"
                label="Treningi z trenerem"
                description="Wcześniejsze treningi pod okiem trenera? Jeśli tak to jak długo?"
                v-model="form.training_with_trainer"
                :objValue="runner.training_with_trainer || 'NIE'"
                :formErrors="formErrors"
                :field="'training_with_trainer'"></runner-step-field>
              <runner-step-field
                :editable="updateMode"
                label="Inne uprawiane sporty"
                v-model="form.other_activities"
                :objValue="runner.other_activities || 'NIE'"
                :formErrors="formErrors"
                :field="'other_activities'"></runner-step-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-end>
          <v-flex class="step-buttons">
            <v-btn dark :to="{name: 'runner-application-data-first', params: {id: $route.params.id}}" class="mr-4" color="tertiary">Wstecz</v-btn>
            <v-btn v-if="updateMode" type="submit" color="primary">Dalej</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import {updateRunnerData2, getRunnerData2} from './api'
import iziToast from 'izitoast'
import { mapGetters } from 'vuex'
import * as types from '@/store/mutation-types'
import RunnerStepField from './RunnerStepField'
import RespHeader from '@/utils/RespHeader'

export default {
  components: {RunnerStepField, RespHeader},
  validators: {
  },
  data () {
    return {
      updateMode: true,
      formErrors: {},
      runner: {},
      form: {},
      packageWithTshirt: false
    }
  },
  computed: {
    ...mapGetters(['allPackagesOptions', 'raceFrequencyOptions', 'tshirtSizeOptions', 'getPackageById'])
  },
  mounted () {
    getRunnerData2(this.$route.params.id).then((data) => {
      this.runner = data
      this.form = {...data}
      this.validation.reset()
    })
    this.$store.dispatch(types.ALL_PACKAGES_REQUEST).then((data) => {
      let packageData = this.getPackageById(this.$store.state.runner.package)
      this.packageWithTshirt = packageData.with_tshirt
    })
  },
  created () {
  },
  methods: {
    updateRunner () {
      this.$validate().then(success => {
        if (success) {
          updateRunnerData2(this.$route.params.id, this.form).then((data) => {
            this.validation.reset()
            this.$emit('runner-data-updated', data)
            iziToast.show({
              message: 'Formularz aplikacyjny został zapisany.',
              color: 'green'
            })
            this.$store.commit(types.RUNNER_DATA_FILLED)
            this.$router.push({name: 'runner-payments', params: {id: this.$route.params.id}})
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/runners/RunnerApplicationDataSecond.vue